import { useCallback } from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CART_URL } from '@yme/common/constants';
import { setInitialCartState } from '@yme/common/redux/cart/actions';
import { deleteCartItems } from '@yme/common/redux/cart/services';
import { checkboxPaymentState } from '@yme/components/CheckoutForm/PaymentForm/constants';
import { CheckoutSteps, CheckoutStepsHashes } from '@yme/components/CheckoutForm/constants';
import { setIsModalHide } from '@yme/modals/actions';
import { COOKIE_KEYS } from '@yme/modals/constants';
import { getLanguageRootPath } from '@yme/selectors/common';
import { CartBroadcastEvents } from '@yme/utils/constants';
import { broadcastCart } from '../App';
export const useModal = () => {
    const languageRootPath = useSelector(getLanguageRootPath);
    const dispatch = useDispatch();
    const history = useHistory();
    const removeCookie = (key) => {
        Cookies.remove(key, {
            path: `${languageRootPath}/`,
        });
    };
    const handleHideModal = useCallback(() => {
        dispatch(setIsModalHide());
    }, [dispatch]);
    const handleProceedToCheckout = () => {
        handleHideModal();
        history.push(`${languageRootPath}/${CART_URL}`);
    };
    const cleanSession = async () => {
        try {
            await dispatch(deleteCartItems());
            dispatch(setInitialCartState());
            dispatch(setIsModalHide());
            COOKIE_KEYS.forEach(removeCookie);
            if (CheckoutStepsHashes.slice(1).includes(history.location.hash)) {
                history.push({
                    hash: CheckoutSteps.CART,
                });
            }
            broadcastCart.postMessage(CartBroadcastEvents.CART_UPDATED);
            localStorage.removeItem(checkboxPaymentState);
        }
        catch (err) {
            console.warn(err);
        }
    };
    return {
        cleanSession,
        handleProceedToCheckout,
        handleHideModal,
    };
};
